export function loadingReducer( state = false, action ){
    switch( action.type ){
        case "SET_LOADING": return action.payload
        default: return state
    }
}

export function apiKeyReducer( key = '', action ){
    switch( action.type ){
        case "SET_API_KEY": return action.payload
        default: return key
    }
}


// WEBPACK FOOTER //
// ./src/components/theme/reducers.js